import { IconMapTrain16 } from '@cian/ui-kit-design-tokens/icons';
import { plural } from '@cian/utils';
import { SpecialGeo } from '../../components/SpecialGeo';
import { useGeneralInfo } from '../../hooks';
import { useMemo } from 'react';
import { stopPropagation } from 'shared/utils/event';

export function RailwayContainer() {
  const { geo } = useGeneralInfo();

  const remoteness = useMemo(() => {
    if (!geo) {
      return;
    }

    const { railway } = geo;

    if (railway && railway.time && railway.time > 0) {
      const unit = plural(railway.time, ['минута', 'минуты', 'минут']);
      const transportType = railway.travelType === 'byFoot' ? 'пешком' : 'на транспорте';

      return `${railway.time} ${unit} ${transportType}`;
    }

    return;
  }, [geo]);

  if (!geo?.railway) {
    return null;
  }

  return (
    <SpecialGeo
      label={geo.railway.name}
      icon={<IconMapTrain16 color="icon-secondary-default" />}
      remoteness={remoteness}
      onClick={stopPropagation}
    />
  );
}
